import { forwardRef } from 'react';
import { IconButton, styled } from '@mui/material';
import { useThemeProps } from '@mui/material/styles';
import { Twitter } from '@mui/icons-material';

export interface ShareOnTwitterButtonProps {
    url?: string;
    text?: string;
}

const ShareOnTwitterButtonRoot = styled(IconButton, {
    name: 'MuiShareOnTwitterButton',
    slot: 'root',
})({});

export const ShareOnTwitterButton = forwardRef<HTMLButtonElement, ShareOnTwitterButtonProps>(
    function ShareOnTwitterButton(inProps, ref) {
        const props = useThemeProps({ props: inProps, name: 'MuiShareOnTwitterButton' });
        const { url, text } = props;
        const myUrlWithParams = new URL('https://twitter.com/intent/tweet');
        if (url) {
            myUrlWithParams.searchParams.append('url', url);
        }
        if (text) {
            myUrlWithParams.searchParams.append('text', text);
        }

        return (
            <ShareOnTwitterButtonRoot
                ref={ref}
                aria-label="Twitter Icon"
                color="primary"
                size="small">
                <a href={myUrlWithParams.href} target="_blank" rel="noopener noreferrer">
                    <Twitter />
                </a>
            </ShareOnTwitterButtonRoot>
        );
    }
);

export default ShareOnTwitterButton;
